import React from "react";
import { useTranslation } from "react-i18next";
import ModalSubmit from "components/common/ModalSubmit";
import Modal from "./Modal";
import BootstrapModalWrapper from "./BootstrapModalWrapper";
const BootstrapModalConfirm = ({
  cancelButtonDisabled = false,
  children,
  confirmButtonDisabled = false,
  confirmButtonText = void 0,
  isAsyncSubmit = void 0,
  isSubmitting = void 0,
  onCancel,
  onConfirm,
  showModal,
  size = void 0,
  submitLoadingText = void 0,
  title,
  ...restProps
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(BootstrapModalWrapper, { showModal, onHide: onCancel, bsSize: size, ...restProps }, /* @__PURE__ */ React.createElement(Modal.Header, null, /* @__PURE__ */ React.createElement(Modal.Title, null, title)), /* @__PURE__ */ React.createElement(Modal.Body, null, children), /* @__PURE__ */ React.createElement(Modal.Footer, null, /* @__PURE__ */ React.createElement(
    ModalSubmit,
    {
      disabledCancel: cancelButtonDisabled,
      disabledSubmit: confirmButtonDisabled,
      isAsyncSubmit,
      submitLoadingText,
      onCancel,
      onSubmit: onConfirm,
      isSubmitting,
      submitButtonText: confirmButtonText != null ? confirmButtonText : t("actions.confirm"),
      submitButtonType: "button"
    }
  )));
};
export default BootstrapModalConfirm;
